(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloom-hero-countdown"] && !Shopify.designMode) return;
  try {
    
  function initializeBloomCountdown(root) {
    if (root.dataset.bloomCountdownReady === 'true') return;

    const loopAnchor = new Date(root.dataset.loopAnchor).getTime();
    const loopDays = Number(root.dataset.loopDays);
    const loopDuration = loopDays * 86400000;
    if (Number.isNaN(loopAnchor) || !Number.isFinite(loopDuration) || loopDuration <= 0) return;

    root.dataset.bloomCountdownReady = 'true';

    const fields = {
      days: root.querySelector('[data-bloom-days]'),
      hours: root.querySelector('[data-bloom-hours]'),
      minutes: root.querySelector('[data-bloom-minutes]'),
      seconds: root.querySelector('[data-bloom-seconds]')
    };

    const pad = (value) => String(value).padStart(2, '0');
    let intervalId;

    const update = () => {
      const now = Date.now();
      const completedLoops = Math.max(0, Math.floor((now - loopAnchor) / loopDuration) + 1);
      const endAt = now < loopAnchor ? loopAnchor : loopAnchor + completedLoops * loopDuration;
      const remaining = endAt - Date.now();

      const totalSeconds = Math.floor(remaining / 1000);
      fields.days.textContent = pad(Math.floor(totalSeconds / 86400));
      fields.hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      fields.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      fields.seconds.textContent = pad(totalSeconds % 60);
    };

    update();
    intervalId = window.setInterval(update, 1000);
  }

  function initializeBloomCountdowns(scope = document) {
    scope.querySelectorAll('[data-bloom-countdown]').forEach(initializeBloomCountdown);
  }

  initializeBloomCountdowns();

  document.addEventListener('shopify:section:load', (event) => {
    initializeBloomCountdowns(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
